import { Fragment } from 'react';
import { Link } from 'react-router-dom';

import SourceLogo from '@/assets/icons/source-logo.svg';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { Typography } from '@/components/ui/typography';
import { useNavigationPaths } from '@/hooks/use-navigation-paths';

interface ConditionalBreadcrumbProps {
  path?: string;
  children: React.ReactNode;
}

function ConditionalBreadcrumb({ path, children }: ConditionalBreadcrumbProps) {
  return path ? (
    <BreadcrumbItem>
      <BreadcrumbLink asChild>
        <Link to={path}>
          <Typography
            variant="subtitle1"
            className="hover:text-fx-primary transition-colors"
          >
            {children}
          </Typography>
        </Link>
      </BreadcrumbLink>
    </BreadcrumbItem>
  ) : (
    <BreadcrumbItem>
      <Typography variant="subtitle1">{children}</Typography>
    </BreadcrumbItem>
  );
}

interface HeaderProps {
  headers: {
    title: string;
    path?: string;
  }[];
}

export function Header({ headers }: HeaderProps) {
  const { dashboardPath } = useNavigationPaths();

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to={dashboardPath}>
              <img src={SourceLogo} alt="Source Logo" className="h-8 w-8" />
              <Typography
                variant="subtitle1"
                className="text-fx-neutral-900 hover:text-fx-primary transition-colors"
              >
                Source
              </Typography>
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {headers.map(({ title, path }) => (
          <Fragment key={title}>
            <BreadcrumbSeparator />
            <ConditionalBreadcrumb path={path}>{title}</ConditionalBreadcrumb>
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
